export interface IInformationBox {
  type: InformationBoxTypes;
  title?: string;
  description?: string;
  links?: Array<Link>;
  hideIcon?: boolean;
  isCircle?: boolean;
  useButtonSlot?: boolean;
}

export interface Link {
  title: string;
  url?: string;
  type?: LinkTypes;
  onClick?: () => void;
}

export enum InformationBoxTypes {
  INFO = 'info',
  INFODARK = 'infodark',
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success',
  MARKETING = 'marketing',
}

export enum LinkTypes {
  LINK = 'link',
  BUTTON_PRIMARY = 'buttonprimary',
  BUTTON_SECONDARY = 'buttonsecondary',
}
